module.exports = __webpack_public_path__ + "img/网站-01.0f53744c.jpg";